module.exports = __webpack_public_path__ + "img/BatAgriSerreV.fbc3eec7.png";